import useSWR from 'swr'
import { fetcher } from '@/services/common'
import type { TypeFetcher } from '@/types/common/fetcher'

export const useSWRFetch = ({
  method,
  url,
  params,
  data,
  headerAppend,
}: TypeFetcher) => {
  const {
    data: result,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR({ method, url, params, data, headerAppend }, fetcher, {
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
      // APIリトライ上限回数チェック
      if (retryCount >= process.env.NEXT_PUBLIC_API_RETRY_COUNT) return

      // status codeが500番台のみAPIリトライ実行
      if (
        error?.response &&
        500 <= error.response.status &&
        error.response.status <= 599
      )
        return setTimeout(
          () => revalidate({ retryCount }),
          2 ** (retryCount - 1) * 1000, // リトライ実行時間は指数関数的に増加
        )
    },
    revalidateOnFocus: false,
  })

  return { result, error, isLoading, isValidating, mutate }
}
